export default __webpack_public_path__ + "static/media/brain_y.f44b1cbd.png";